import axiosInstance from '../axiosConfigCMS';

export default {
  async getCategories(params) {
    const response = await axiosInstance.get(`/categories${params ?? ``}`);
    return response.data;
  },
  async getProductsByCategoryId(categoryId) {
    const response = await axiosInstance.get(`/categories/${categoryId}`);
    return response.data;
  },
};
